import { IssueSearch } from 'interface/issueInterface';
import CommonTable, { HeadCell } from '../common/TableCommon';
import { useEffect, useState } from 'react';
import { useAppSelector } from 'hooks/reduxHooks';
import { RootState } from 'redux-setup/store';
import { Issue } from 'interface/issueInterface';
import issueService from 'services/issueService';

const Issues = () => {
  const [issueData, setIssueData] = useState<Issue[]>([]);
  const [isNextAPIDisabled, setIsNextAPIDisabled] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const limit = 25;

  const organizationId = useAppSelector(
    (state: RootState) => state.organization.id,
  );

  const searchIssue = async () => {
    try {
      const payload: IssueSearch = {
        Page: page - 1,
        Limit: limit,
        OrganizationID: organizationId,
        Descending: false,
        OrderBy: 'Number',
      };
      const res = await issueService.searchIssues(payload);
      if (res.data && res.data.Result) {
        setIssueData(prev => [...prev, ...res.data.Result]);
        setIsNextAPIDisabled(res.data.Result.length < limit);
      }
    } catch (error) {
      setIssueData([]);
    }
  };

  useEffect(() => {
    searchIssue();
  }, [page]);

  const headCellList: HeadCell<Issue>[] = [
    {
      id: 'number',
      label: 'Number',
      hide: false,
      cellRender: row => {
        return <>{row?.Number}</>;
      },
    },
    {
      id: 'title',
      label: 'Title',
      hide: false,
      cellRender: row => {
        return row?.HTMLURL ? (
          <a href={row.HTMLURL} target="_blank" rel="noopener noreferrer">
            {row.Title}
          </a>
        ) : null;
      },
    },
    {
      id: 'author',
      label: 'Author',
      hide: false,
      cellRender: row => {
        return <>{row?.GithubAuthorName}</>;
      },
    },
    {
      id: 'assignee',
      label: 'Assignee',
      hide: false,
      cellRender: row => {
        return <>{row?.AssigneeName}</>;
      },
    },
    {
      id: 'status',
      label: 'Status',
      hide: false,
      cellRender: row => {
        if (!row) return null;
        return <>{row.State}</>;
      },
    },
    {
      id: 'labels',
      label: 'Labels',
      hide: false,
      cellRender: row => {
        return <>{row?.Labels?.join(', ') || ''}</>;
      },
    },
    {
      id: 'htmlUrl',
      label: 'URL',
      hide: false,
      cellRender: row => {
        return row?.HTMLURL ? (
          <a href={row.HTMLURL} target="_blank" rel="noopener noreferrer">
            {row.HTMLURL}
          </a>
        ) : null;
      },
    },
    {
      id: 'repository',
      label: 'Repository',
      hide: false,
      cellRender: row => {
        return <>{row?.RepositoryName}</>;
      },
    },
    {
      id: 'createdAt',
      label: 'Created At',
      hide: false,
      cellRender: row => {
        return (
          <>
            {row?.IssueCreatedAt
              ? new Date(row.IssueCreatedAt).toLocaleString()
              : ''}
          </>
        );
      },
    },
    {
      id: 'updatedAt',
      label: 'Updated At',
      hide: false,
      cellRender: row => {
        return (
          <>
            {row?.IssueUpdatedAt
              ? new Date(row.IssueUpdatedAt).toLocaleString()
              : ''}
          </>
        );
      },
    },
    {
      id: 'closedAt',
      label: 'Closed At',
      hide: false,
      cellRender: row => {
        return (
          <>{row?.ClosedAt ? new Date(row.ClosedAt).toLocaleString() : ''}</>
        );
      },
    },
  ];
  return (
    <CommonTable<Issue>
      headCellList={headCellList}
      data={issueData}
      isNextAPIDisabled={isNextAPIDisabled}
      onEndReached={() => {
        setPage(prev => prev + 1);
      }}
    />
  );
};

export default Issues;
